import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format a translated text from Kentico to replace <<text>> with a value
 *
 * Usage:
 *   value | placeholder
 * Example:
 *   {{ These are my <<number>> cats |  placeholder('3')}}
 *   formats to: These are my 3 cats
 */

@Pipe({
    name: 'placeholder',
    standalone: true
})
export class PlaceholderPipe implements PipeTransform {
	transform(value: any, replacementValue: any): string {
		if (value && replacementValue) {
			return value.replace(value.slice(value.indexOf('<<'), value.indexOf('>>') + 2), replacementValue);
		}
		return value;
	}
}
